import styled from "styled-components";

export const Loader = styled.div`
    height: 100%;
    // min-height: 500px;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
`;